// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-grid-manager {\n  height: 100%;\n}\n\n.flex-background-widget {\n  position: absolute;\n  top:0;\n  bottom:0;\n  left:0;\n  right:0;\n  z-index: 0;\n}\n\n.autowidth {\n  flex: 1; \n}\n\n.flex-widget {\n  height: 100%;\n  width: 100%;\n  /* z-index: 150; */\n}\n", ""]);
// Exports
module.exports = exports;
